import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '51947756273'; // Pérou: +51 + numéro
  const message = encodeURIComponent('Bonjour! Je souhaite obtenir une estimation gratuite pour le lavage de vitres.');

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      aria-label="Contactez-nous sur WhatsApp"
    >
      <MessageCircle size={28} />
    </a>
  );
};

export default WhatsAppButton;
